export default {
    orientation: {
        row: 'row',
        column: 'column',
    },
    alignment: {
        leftOrTop: 'leftOrTop',
        center: 'center',
        rightOrBottom: 'rightOrBottom',
        stretch: 'stretch',
    },
};
